import { render, staticRenderFns } from "./CreateCandle.vue?vue&type=template&id=069b68ca&"
import script from "./CreateCandle.vue?vue&type=script&lang=js&"
export * from "./CreateCandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports